import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  SET_SWITCHES_FILTERS,
  GET_LIST_PRODUCT_REQUEST,
  GET_LIST_PRODUCT_SUCCESS,
  SEARCH
} from './product-list-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const getListProductsRequest = (payload: {
  queryString?: string;
  subsidiaryExternalCode?: string;
  brand?: string;
  onlyWithStock?: boolean;
  onlyExternalCode?: boolean;
}) => {
  return {
    type: GET_LIST_PRODUCT_REQUEST,
    payload
  };
};

export const getListProductsSuccess = payload => {
  return {
    type: GET_LIST_PRODUCT_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setRowsOrientation = (rowsOrientation: string) => {
  return {
    type: SET_ROWS_ORIENTATION,
    rowsOrientation
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const setSwitchesFilters = (payload: { name: string; value: boolean }) => {
  return {
    type: SET_SWITCHES_FILTERS,
    payload
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};
